import { render } from "./InputFileUploadCompact.vue?vue&type=template&id=4066bca5&scoped=true"
import script from "./InputFileUploadCompact.vue?vue&type=script&lang=js"
export * from "./InputFileUploadCompact.vue?vue&type=script&lang=js"

import "./InputFileUploadCompact.vue?vue&type=style&index=0&id=4066bca5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4066bca5"]])

export default __exports__